import { createElement, FC, SVGProps } from "react";
import CuttingOperationsIcon from "~icons/operations/cuttingOperations";
import ExpenseNonRecurringIcon from "~icons/operations/expenseNonRecurring";
import FinishingOperationAreaDependentIcon from "~icons/operations/finishingOperationAreaDependent";
import LaserCuttingIcon from "~icons/operations/laserCutting";
import MaterialCustomerProvidedIcon from "~icons/operations/materialCustomerProvided";
import MaterialPlateIcon from "~icons/operations/materialPlate";
import MaterialPlateSheetIcon from "~icons/operations/materialPlateSheet";
import MaterialPurchasedComponentIcon from "~icons/operations/materialPurchasedComponent";
import MaterialRectangularBarIcon from "~icons/operations/materialRectangularBar";
import MaterialRectangularTubeIcon from "~icons/operations/materialRectangularTube";
import MaterialRoundBarIcon from "~icons/operations/materialRoundBar";
import MaterialSheetIcon from "~icons/operations/materialSheet";
import OperationNonRecurringTimeDependentIcon from "~icons/operations/operationNonRecurringTimeDependent";
import OperationPerPartTimeDependentIcon from "~icons/operations/operationPerPartTimeDependent";
import PurchasedComponentIcon from "~icons/operations/purchasedComponent";
import WaterjetCuttingIcon from "~icons/operations/waterjetCutting";
import MaterialPurchasedPartIcon from "~icons/operations/materialPurchasedPart";
import { components } from "@/lib/ApiSchema";

const operationIcons: Record<
  components["schemas"]["CalculatorTypeEnum"],
  FC<SVGProps<SVGSVGElement>>
> = {
  CuttingOperations: CuttingOperationsIcon,
  ExpenseNonRecurring: ExpenseNonRecurringIcon,
  FinishingOperationAreaDependent: FinishingOperationAreaDependentIcon,
  LaserCutting: LaserCuttingIcon,
  MaterialCustomerProvided: MaterialCustomerProvidedIcon,
  MaterialPlate: MaterialPlateIcon,
  MaterialPreCutBlanks: MaterialPlateIcon,
  MaterialPlateSheet: MaterialPlateSheetIcon,
  MaterialPurchasedComponent: MaterialPurchasedComponentIcon,
  MaterialRectangularBar: MaterialRectangularBarIcon,
  MaterialFullRectangularBar: MaterialRectangularBarIcon,
  MaterialRectangularTube: MaterialRectangularTubeIcon,
  MaterialRoundBar: MaterialRoundBarIcon,
  MaterialFullRoundBar: MaterialRoundBarIcon,
  MaterialSheet: MaterialSheetIcon,
  MaterialSheetV2: MaterialSheetIcon,
  OperationNonRecurringTimeDependent: OperationNonRecurringTimeDependentIcon,
  OperationPerPartTimeDependent: OperationPerPartTimeDependentIcon,
  PurchasedComponent: PurchasedComponentIcon,
  MaterialPurchasedPart: MaterialPurchasedPartIcon,
  WaterjetCutting: WaterjetCuttingIcon,
};

export default function OperationTypeIcon({
  operationType,
  className,
}: {
  operationType: components["schemas"]["CalculatorTypeEnum"];
  className?: string;
}) {
  return createElement(operationIcons[operationType], {
    className,
  });
}
